export const ACCESS_TOKEN = 'ACCESS_TOKEN'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const SHAIN_NO = 'SHAIN_NO'
export const SHAIN_NAME = 'SHAIN_NAME'
export const AUTH_LEVEL = 'AUTH_LEVEL'
export const SEARCH_SHAIN_NO = 'SEARCH_SHAIN_NO'
export const POSITION_DISP_DATA = 'POSITION_DISP_DATA'
export const POSITION_FLG_LIST = 'POSITION_FLG_LIST'
export const OFFICEMASTER_ADDRESS = 'OFFICEMASTER_ADDRESS'
export const OFFICEMASTER_OPEN_ON = 'OFFICEMASTER_OPEN_ON'
export const OFFICEMASTER_CLOSE_ON = 'OFFICEMASTER_CLOSE_ON'
export const OFFICEMASTER_IS_HIDDEN = 'OFFICEMASTER_IS_HIDDEN'
export const MENU = 'MENU'



// WEBPACK FOOTER //
// ./src/store/utils/mutation-types.js